//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatTime } from '../../components/helpers.js'
import ImageViewer from '../../components/Images/ImageViewer.vue'
import { EventBus } from '../../EventBus/EventBus.js'

export default {
  components: {
    ImageViewer: ImageViewer
  },
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    reportRoadsTitle: {
      type: String,
      default: ''
    },
    reportRoadsImages: {
      type: Array,
      default () {
        return []
      }
    },
    imagesFromRequestSmall: {
      type: Array,
      default () {
        return []
      }
    },
    imagesFromRequest: {
      type: Array,
      default () {
        return []
      }
    },
    reportsDocuments: {
      type: Array,
      default () {
        return []
      }
    },
    serviceObjectId: {
      type: Number,
      default: null
    },
    reportsHistoryLoaded: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      selectedReportId: null,
      selectedReportDocuments: null,
      ts: true,
      beforeWork: true,
      inWork: true,
      afterWork: true,
      audit: true,
      advertisment: true,
      selectFromHistory: false,
      searchValue: '',

      reportRoadsImagesLocal: [],

      loading: false,

      formatTime
    }
  },
  computed: {
    dialogOpened: function () {
      return this.opened
    },
    reportsDocumentsOptions: function () {
      const activeReportsDocumentsIds = this.reportsDocuments.filter(report => !report.fromHistory).map(report => report.id)
      const options = this.selectFromHistory
        ? this.reportsDocuments.filter(report => !(report.fromHistory && activeReportsDocumentsIds.includes(report.id)))
        : this.reportsDocuments.filter(report => !report.fromHistory)
      return options.filter(option => option.name.toLowerCase().includes(this.searchValue.toLowerCase()))
    }
  },
  watch: {
    selectedReportId: function () {
      for (const reportDocuments of this.reportsDocumentsOptions) {
        if (reportDocuments.id === this.selectedReportId) {
          this.selectedReportDocuments = reportDocuments
          break
        }
      }
    },
    opened: function (result) {
      if (result) {
        this.reportRoadsImagesLocal = this.reportRoadsImages
        if (this.reportsDocuments.filter(report => !report.fromHistory).length === 0 && this.serviceObjectId) {
          this.selectFromHistory = true
        }
        if (!this.selectedReportId && !this.selectFromHistory) {
          this.selectedReportId = this.reportsDocumentsOptions.length ? this.reportsDocumentsOptions[this.reportsDocumentsOptions.length - 1].id : null
        } else if (!this.selectedReportId && this.selectFromHistory) {
          this.selectedReportId = this.reportsDocumentsOptions.length ? this.reportsDocumentsOptions[0].id : null
        }
      }
    },
    selectFromHistory: function (result) {
      if (!result || !this.selectedReportId) {
        this.selectedReportId = this.reportsDocumentsOptions.length ? this.reportsDocumentsOptions[result ? 0 : this.reportsDocumentsOptions.length - 1].id : null
      }
      if (!this.selectedReportId) {
        this.selectedReportDocuments = null
      }
      if (result && !this.reportsHistoryLoaded) {
        EventBus.$emit('reports-history-load') // Запуск загрузки истории отчетов в ReportRoads.vue -> function loadAndPrepareReportsFromHistory()
        this.loading = true
      }
    }
  },
  created: function () {
    EventBus.$on('reports-history-load-end', this.onHistoryLoadEnd)
  },
  beforeDestroy: function () {
    EventBus.$off('reports-history-load-end', this.onHistoryLoadEnd)
  },
  methods: {
    onHistoryLoadEnd: function () {
      this.loading = false
    },
    filterReportsDocuments: function (val, update) {
      update(() => {
        this.searchValue = val
      })
    },
    confirm: function () {
      this.$emit('confirm', this.reportRoadsImagesLocal)
    },
    close: function () {
      this.$emit('close')
    },
    getBackgroundImageStyle: function (imageUrl) {
      return 'background-image: url("' +
              imageUrl +
              '"); background-size: cover; background-position: 50%;'
    },
    onShowPreview: function (images, index) {
      this.$refs.imagesViewer.show(images, index)
    },
    onSelectImage: function (image) {
      this.selectOrDeleteImage(image)
    },
    selectOrDeleteImage: function (image) {
      const deleteImage = this.reportRoadsImagesLocal
        .map(image => image.id)
        .includes(image.id)

      if (!deleteImage) {
        this.reportRoadsImagesLocal.push(image)
      } else {
        this.reportRoadsImagesLocal = this.reportRoadsImagesLocal
          .filter(img => img.id !== image.id)
      }
    },
    selectOrDeleteImageFromReport: function (image) {
      const deleteImage = this.reportRoadsImagesLocal
        .map(image => image.id)
        .includes(image.id)

      if (!deleteImage) {
        const fullImage = this.selectedReportDocuments.reportImages.filter(fullImage => fullImage.id === image.id)[0]
        this.reportRoadsImagesLocal.push(fullImage)
      } else {
        this.reportRoadsImagesLocal = this.reportRoadsImagesLocal
          .filter(img => img.id !== image.id)
      }
    }
  }
}

